import { useCheckboxGroup } from '@chakra-ui/react'
import { useAtom } from 'jotai'

import { Box } from '@/components/ui/box'
import { Checkbox } from '@/components/ui/checkbox'
import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import { ILanguage, selectedLanguagesAtom, toggleSelectedLanguages } from '@/store/translate'

const OptionsGroup = ({ data, title }: { data: ILanguage[]; title?: string }) => {
    const [selectedLangs] = useAtom(selectedLanguagesAtom)
    const { getItemProps } = useCheckboxGroup()

    if (data.length === 0) return null

    return (
        <Box pb="8px">
            {title && (
                <Text
                    fontSize="12px"
                    color="rgba(84, 79, 64, 0.7)"
                    _dark={{ color: 'rgba(255, 255, 255, 0.7)' }}
                    textTransform="capitalize"
                    pb="4px"
                >
                    {title}
                </Text>
            )}
            <Flex flexWrap="wrap" gap="2%">
                {data.map((item) => (
                    <Flex key={item.languageCode} width="48%" my="10px" alignItems="center">
                        <Checkbox
                            {...getItemProps({ value: item.languageCode })}
                            onCheckedChange={() => toggleSelectedLanguages(item)}
                            checked={selectedLangs.findIndex((el) => el.languageCode === item.languageCode) !== -1}
                        />
                        <Text pl="20px" fontSize="14px" onClick={() => toggleSelectedLanguages(item)} cursor="pointer">
                            {item.languageEnglishName}
                        </Text>
                    </Flex>
                ))}
            </Flex>
        </Box>
    )
}

export default OptionsGroup
